import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalController } from '@ionic/angular/standalone';
import { BanModalComponent } from '../components/ban-modal.component';

@Injectable()
export class RateLimitInterceptor implements HttpInterceptor {
  private modalCtrl = inject(ModalController);
  private readonly localBanDurationMs = 2 * 60 * 60 * 1000;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const bannedUntil = localStorage.getItem('ip_banned_until');
    if (bannedUntil && Date.now() < +bannedUntil) {
      this.showBanModal('You are temporarily restricted. Please try again later.');
      return throwError(() => new HttpErrorResponse({ status: 429 }));
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 429) {
          const message = error.error?.error || "You've hit a temporary request limit. Please try again later.";
          localStorage.setItem('ip_banned_until', (Date.now() + this.localBanDurationMs).toString());
          this.showBanModal(message);
        }
        return throwError(() => error);
      })
    );
  }

  private async showBanModal(message: string) {
    const modal = await this.modalCtrl.create({
      component: BanModalComponent,
      componentProps: { message },
      backdropDismiss: false,
      cssClass: 'ban-modal-overlay',
    });
    await modal.present();
  }
}
